import React, { useState, useEffect } from "react";
import {
  // useLocation, 
    useNavigate
} from "react-router-dom";
import { 
    AppBar, 
    Avatar, 
    Box, 
    Typography,
    Menu,
    MenuItem,
    Toolbar,
    // Link,
} from "@mui/material";
import { grey } from "@mui/material/colors";
import getlistssmall from "../assets/images/logoDark.png";
import { logoutUser } from "../services/authService";
import { getUserById } from "../services/userService";
import { pictureUrlToString } from "../utils/pictureUrl";

const DefaultAppBar = () => {
    const navigate = useNavigate();
    // const location = useLocation();
    const userInfo = typeof window !== 'undefined' ? localStorage.getItem('userInfo') : null;
    const user = userInfo ? JSON.parse(userInfo) : null;

    // State for updated user data
    const [updatedUser, setUpdatedUser] = useState(user);

    useEffect(() => {
        if (!userInfo) {
            navigate('/login');
        }
    }, [userInfo, navigate]);

    // Fetch user data every 5 seconds
    useEffect(() => {
        if (!user || !user._id) return;
        const fetchUserData = async () => {
            try {
                const userData = await getUserById(user._id);
                setUpdatedUser(userData);
                localStorage.setItem('userInfo', JSON.stringify(userData));
            } catch (error) {
                console.error('Error fetching user data:', error);
            }
        };
        fetchUserData();
        const interval = setInterval(fetchUserData, 5000);
        return () => clearInterval(interval);
    }, [user?._id]);

    // State variables
    const [anchorEl, setAnchorEl] = useState(null);

    // Event handlers
    const handleProfileMenu = (event) => {
      setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };
    const handleLogout = () => {
        logoutUser();
        window.location.href = "/login";
      };
      
    return (
      <AppBar 
        position="sticky" 
        elevation={2} 
        sx={{ 
          bgcolor: "black", 
          color: grey[500], 
          boxShadow: 1, 
          // minHeight: 75, 
          // maxHeight: 75, 
          // padding: 0
        }}
      >
        <Toolbar 
          sx={{ 
            display: 'flex', 
            justifyContent: 'space-between', 
            alignItems: 'flex-start', 
            width: '100%',
            pt:1,
            pb:1
          }}
        >
          <Box 
            display="flex" 
            alignItems="center" 
            gap={2} 
            sx={{ marginLeft: "auto" }}
          >
            <Box 
              display="flex" 
              alignItems="center" 
              padding={1} 
              margin={1} 
              sx={{ 
                display: { xs: 'none', md: 'flex' }, 
                px: 2, 
                bgcolor: "#232323", 
                color: "#fff", 
                fontWeight: 100, 
                borderRadius: 2, 
                fontSize: "1rem"
              }}
            >
              <Box component="span" sx={{ color: "#fff", fontWeight: 100, ml: 1 }}>Credits : </Box>
              <Box component="span" sx={{ color: "#1BE885", fontWeight: 100, mx: 0.5 }}>{updatedUser?.remainingCredits || user?.remainingCredits} </Box>
              {/* <Box component="span" sx={{ color: "#fff", fontWeight: 100 }}>/ {user.totalCredits}</Box> */}
            </Box>
          
  

            <Box display="flex" alignItems="center" sx={{ cursor: "pointer", marginRight: 1 }} onClick={handleProfileMenu}>
                <Avatar
                  src={
                    pictureUrlToString(updatedUser?.profilePicture) ||
                    pictureUrlToString(user?.profilePicture)
                  }
                  sx={{ width: 36, height: 36, mr: 1 }}
                />
                <Typography variant="body1" sx={{ fontWeight: 600, display: { xs: 'none', md: 'block' } }} >{updatedUser?.firstName ? updatedUser.firstName.charAt(0).toUpperCase() + updatedUser.firstName.slice(1).toLowerCase() : user?.firstName ? user.firstName.charAt(0).toUpperCase() + user.firstName.slice(1).toLowerCase() : ''}</Typography>
            </Box>
            
            <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleClose} anchorOrigin={{ vertical: "bottom", horizontal: "right" }} transformOrigin={{ vertical: "top", horizontal: "right" }}>
                <MenuItem component="a" href="/account">Profile</MenuItem>
                <MenuItem onClick={handleLogout}>Logout</MenuItem>
            </Menu>
              
          </Box>
          </Toolbar>
      </AppBar>
    );
};

export default DefaultAppBar;